/**
 * PHASE 1: Structured Global Solar Dataset
 * Generated using installer-grade conservative Peak Sun Hours (PSH).
 * Logic: Based on worst-month irradiance patterns to prevent system under-sizing.
 */

export const SOLAR_DATASET = [
  // --- AFRICA ---
  { "country": "Nigeria", "city": "Lagos", "psh": 3.5 },
  { "country": "Nigeria", "city": "Abuja", "psh": 5.0 },
  { "country": "Nigeria", "city": "Kano", "psh": 5.8 },
  { "country": "Nigeria", "city": "Port Harcourt", "psh": 3.2 },
  { "country": "Ghana", "city": "Accra", "psh": 3.8 },
  { "country": "Ghana", "city": "Kumasi", "psh": 4.2 },
  { "country": "Kenya", "city": "Nairobi", "psh": 4.5 },
  { "country": "Kenya", "city": "Mombasa", "psh": 5.2 },
  { "country": "South Africa", "city": "Cape Town", "psh": 4.8 },
  { "country": "South Africa", "city": "Johannesburg", "psh": 5.2 },
  { "country": "Egypt", "city": "Cairo", "psh": 5.5 },
  { "country": "Rwanda", "city": "Kigali", "psh": 4.0 },

  // --- EUROPE ---
  { "country": "United Kingdom", "city": "London", "psh": 1.8 },
  { "country": "United Kingdom", "city": "Manchester", "psh": 1.5 },
  { "country": "Netherlands", "city": "Amsterdam", "psh": 2.2 },
  { "country": "Germany", "city": "Berlin", "psh": 2.0 },
  { "country": "Germany", "city": "Munich", "psh": 2.5 },
  { "country": "Spain", "city": "Madrid", "psh": 4.5 },
  { "country": "Italy", "city": "Rome", "psh": 4.0 },
  { "country": "France", "city": "Paris", "psh": 2.3 },

  // --- NORTH AMERICA ---
  { "country": "United States", "city": "Los Angeles", "psh": 5.5 },
  { "country": "United States", "city": "Phoenix", "psh": 6.2 },
  { "country": "United States", "city": "New York", "psh": 3.2 },
  { "country": "United States", "city": "Miami", "psh": 4.8 },
  { "country": "Canada", "city": "Toronto", "psh": 2.8 },
  { "country": "Canada", "city": "Vancouver", "psh": 2.0 },

  // --- ASIA / MIDDLE EAST ---
  { "country": "United Arab Emirates", "city": "Dubai", "psh": 5.8 },
  { "country": "India", "city": "Mumbai", "psh": 4.2 },
  { "country": "India", "city": "Delhi", "psh": 4.8 }
];